// Generic wrapper: any button inside <add-to-cart-trigger data-variant-id="123">
// dispatches the shared 'cart:add' event cart-drawer.js listens for.
class AddToCartTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-variant-id]');
      if (!button || button.disabled) return;
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      const quantity = Number(button.dataset.quantity || 1);
      document.dispatchEvent(
        new CustomEvent('cart:add', { detail: { items: [{ id: variantId, quantity }] } })
      );
    });
  }
}

if (!customElements.get('add-to-cart-trigger')) {
  customElements.define('add-to-cart-trigger', AddToCartTrigger);
}
